import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { Input, InputDate, Textarea, FilePicker } from 'components/fields'
import { ElevatedButton } from 'components/layout'
import { form } from 'helpers/decorators'
import { uploadFileValidation } from 'models/awards'
import styles from './assessor-file-upload.styl'

@form({
  form: 'assessorFileUpload',
  disableHook: true,
  validate: uploadFileValidation
})
class AssessorFileUpload extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    values: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    assessorId: PropTypes.number.isRequired,
    activityId: PropTypes.number.isRequired,
    activityCategoryId: PropTypes.number.isRequired,
    assessorRegistrationId: PropTypes.number.isRequired,
    ajEventId: PropTypes.number.isRequired,
    residentialProjectId: PropTypes.number.isRequired,
    authCode: PropTypes.string,
    withWWCNumber: PropTypes.bool,
    withoutAssessor: PropTypes.bool
  }

  render() {
    const {
      handleSubmit,
      values,
      loading,
      assessorId,
      activityId,
      activityCategoryId,
      ajEventId,
      residentialProjectId,
      authCode,
      assessorRegistrationId,
      withWWCNumber,
      withoutAssessor
    } = this.props

    const submitData = {
      assessorId,
      activityId,
      activityCategoryId,
      ajEventId,
      residentialProjectId,
      assessorRegistrationId,
      withoutAssessor
    }

    return (
      <form
        onSubmit={handleSubmit(fields => this.props.onSubmit(fields, authCode, submitData)
        )}
      >
        <Input label="Title" intlKey="label.title" name="title" />
        <Textarea
          label="Description"
          intlKey="label.description"
          name="description"
        />
        <div className={`base-margin desc ${styles.bottom}`}>
          <FilePicker
            name="file"
            change={this.props.change}
            className="testing"
            supportedTypes={[
              'text/html',
              'text/plain',
              'image/jpeg',
              'image/png',
              'application/msword',
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              'application/vnd.openxmlformats-officedocument.presentationml.presentation',
              'application/pdf',
              'video/mp4']}
          />
          {withWWCNumber && (<>
            <div>
              <Input
                name="childProtectionNumber"
                intlKey="label.wwc_application_number"
                label="Child protection number"
              />
              <InputDate
                name="childProtectionExpirationDate"
                intlKey="label.wwc_expiration_date"
                label="Child Protection expiration date"
              />
            </div>
          </>)}
        </div>

        <ElevatedButton
          intlKey="button.add_file"
          disabled={!get(values, 'file')}
          isLoading={loading}
          submit
          rounded
          uppercase
          fullWidth
        >
          Add file
        </ElevatedButton>
      </form>
    )
  }
}

export default AssessorFileUpload
